import { If } from "react-conditional-components-renderer";
import classNames from "classnames";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscSelectInput from "../../AscInputFields/AscSelectInput/AscSelectInput";

import { TrashIcon } from "../../AscIcons";

import styles from "./AscActivityQuestionAnswerForm.module.scss";
import { FormikInstance, TRUE_FALSE_OPTIONS } from "@ascendnow/shared";
import { FormikValues } from "formik";

export interface AscActivityQuestionAnswerFormProps<T extends FormikValues> {
  className?: string;
  withGroup?: boolean;
  withCellNumber?: boolean;
  isDescription?: boolean;
  onBlur?: (value: object) => void;
  selectBooleanOptions?: typeof TRUE_FALSE_OPTIONS;
  selectedGroup?: { name: string };
  selectAnswerOptions?: {
    name: string;
  }[];
  formik?: FormikInstance<T>;
  formikNamePrefix?: string;
  defaultValue?: any; //TODO: fix type!
  onDelete?: () => void;
  canDelete?: boolean;
  hideDelete?: boolean;
}

export default function AscActivityQuestionAnswerForm<T extends FormikValues>({
  className,
  withGroup = false,
  withCellNumber = false,
  isDescription = false,
  onBlur,
  selectBooleanOptions,
  selectedGroup,
  selectAnswerOptions,
  formik,
  formikNamePrefix,
  defaultValue,
  onDelete,
  canDelete = false,
  hideDelete = false,
}: AscActivityQuestionAnswerFormProps<T>) {
  return (
    <div
      className={classNames(
        styles.ground,
        {
          [styles.hideDelete]: hideDelete,
        },
        className
      )}
    >
      <div className={styles.form}>
        {withCellNumber && (
          <div className={styles.formField}>
            <label className={styles.fieldLabel} htmlFor="cellNumber">
              No
            </label>
            <div className={styles.inputField}>
              <AscTextInput
                fullWidth={true}
                placeholder=""
                id="cellNumber"
                name="cellNumber"
                onChange={formik?.handleChange}
                onBlur={(e) =>
                  onBlur?.({ beginningCellNumber: Number(e?.target?.value) })
                }
                defaultValue={defaultValue?.beginningCellNumber}
              />
            </div>
          </div>
        )}

        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="question">
            {withGroup === false ? "Question" : "Group"}
          </label>
          <div className={styles.inputField}>
            <If test={withGroup === false}>
              <AscTextInput
                fullWidth={true}
                placeholder="Enter question"
                id="question"
                name={`${formikNamePrefix}.question`}
                onChange={formik?.handleChange}
                onBlur={(e) => onBlur?.({ clue: e?.target?.value })}
                defaultValue={defaultValue && defaultValue?.question}
              />
            </If>

            <If test={withGroup === true}>
              <AscTextInput
                fullWidth={true}
                placeholder="Select group"
                id="group"
                name={`${formikNamePrefix}.name`}
                value={selectedGroup?.name}
                disabled
                defaultValue={selectedGroup?.name}
              />
            </If>

            <hr className={styles.hR} />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.trashIcon, {
                [styles.iconDisabled]: !canDelete,
              })}
            />
          </div>
        </div>

        <div className={styles.formField}>
          <label className={styles.fieldLabel} htmlFor="answer">
            {isDescription ? "Description" : "Answer"}
          </label>
          <div className={styles.inputField}>
            <If
              test={
                Boolean(selectAnswerOptions) === false &&
                Boolean(selectBooleanOptions) === false
              }
            >
              <AscTextInput
                fullWidth={true}
                placeholder={`Enter ${
                  isDescription ? "description" : "answer"
                }`}
                id={isDescription ? "description" : "answer"}
                name={
                  isDescription
                    ? `${formikNamePrefix}.description`
                    : `${formikNamePrefix}.answer`
                }
                onChange={formik?.handleChange}
                onBlur={(e) => onBlur?.({ word: e?.target?.value })}
                defaultValue={
                  defaultValue && isDescription
                    ? defaultValue?.description
                    : defaultValue?.answer
                }
              />
            </If>

            <If test={Boolean(selectAnswerOptions) === true}>
              <AscSelectInput
                fullWidth={true}
                placeholder="Select answer"
                id="answer"
                name={`${formikNamePrefix}.answer`}
                multiple={true}
                onChange={(val) =>
                  formik?.setFieldValue(`${formikNamePrefix}.answers`, val)
                }
                defaultValue={
                  defaultValue?.answers?.length
                    ? defaultValue?.answers.map(
                        (index: any) => selectAnswerOptions?.[index]?.name
                      )
                    : undefined
                }
              >
                {selectAnswerOptions?.map(
                  ({ name }: { name: string }, index: number) => (
                    <AscSelectInput.Option
                      key={index}
                      value={index}
                      label={name}
                    />
                  )
                )}
              </AscSelectInput>
            </If>

            <If test={Boolean(selectBooleanOptions) === true}>
              <AscSelectInput
                fullWidth={true}
                placeholder="Select true or false"
                id="answer"
                name={`${formikNamePrefix}.answer`}
                onChange={(val) =>
                  formik?.setFieldValue(`${formikNamePrefix}.answer`, val)
                }
                defaultValue={defaultValue?.answer}
              >
                {selectBooleanOptions?.map(
                  ({ name, value }: { name: string; value: string }) => (
                    <AscSelectInput.Option
                      key={value}
                      value={value}
                      label={name}
                    />
                  )
                )}
              </AscSelectInput>
            </If>

            <hr className={styles.hR} />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.trashIcon, {
                [styles.iconDisabled]: !canDelete,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
